<template>
    <div class="col-12 row">
        <div class="col-9 row">
            <select :name="fieldName" v-model="currentAddress" class="form-control">
                <option v-text="selectText" value=""></option>
                <option v-for="option in addressOptions" :value="option.id" v-text="option.label"></option>
            </select>
        </div>
        <div class="col-2 row">
            <a @click="openCreate()" class="mt0 btn btn-success small primary ml5" target="_blank" v-show="debtor !== ''">
                <i class="fa fa-plus"></i>
            </a>

            <a v-show="debtor !== '' && currentAddress > 0" @click="openEdit()" class="mt0 btn btn-secondary small yellow ml5">
                <i class="fa fa-edit"></i>
            </a>
        </div>
    </div>
</template>

<script>
import {EventBus} from "../../events";

export default {
    name: "AddressSelect",

    props: {
        selectedAddress: {
            required: false,
            type: String
        },
        selectedDebtor: {
            required: false,
            type: String
        },
        type: {
            required: false,
            default: "4"
        },
        fieldName: {
            required: false,
            default: 'delivery_address'
        }
    },
    data: function() {
        return {
            addressOptions: [],
            debtor: null,
            currentAddress: null,
            selectText: 'Kies eerst een klant..'
        }
    },
    methods: {
        loadOptions: function(debtorId) {
            axios.get(`/api/backend/addresses/?debtor_id=${debtorId}&type=${this.type}`)
            .then(response => {
                let options = [];
                if (response.data) {
                    options = response.data.data.map(i => ({
                        id: `${i.id}`,
                        label: `${i.address}`,
                    }));
                }
                this.addressOptions = options;
                this.selectText = 'Kies een adres';
            });
        },
        openEdit() {
            $('body').addClass('addressCreate');
            $.fancybox.open({
                src: '/addresses/popup/'+this.currentAddress+'/edit/',
                type: 'iframe'
            });
        },
        openCreate() {
            $('body').addClass('addressCreate');
            $.fancybox.open({
                src: '/addresses/popup/create/'+this.type+'/'+this.debtor.id,
                type: 'iframe',
            });
        },
    },
    computed: {
        iframeDataAddress () {
            return window.iframeDataAddress;
        }
    },
    watch: {
        iframeDataAddress: function(newData) {
            if(newData != null) {
                this.currentSelected = iframeDataAddress;
                this.loadOptions(this.debtor.id);
            }
        },
    },
    mounted() {
        this.currentAddress = this.selectedAddress;
        this.debtor = this.selectedDebtor;

        EventBus.$on('changeDebtor', (debtor) => {
            this.debtor = debtor;
            this.loadOptions(debtor.id);
        });

        EventBus.$on('refreshAddresses', (addressId, type) => {
            if(type == this.type) {
                this.loadOptions(this.debtor.id);
                this.currentAddress = addressId;
            }
        });
    }
}
</script>

<style scoped>

</style>
